module.exports = __webpack_public_path__ + "static/media/logo.d6116918.png";